<template>
    <div>
        <el-card class="box-card">
            <div style="margin-left:20px;margin-right:20px">
                <div style="height:32px">

                   <div style="float:right">
                        <el-input
                        size="small"
                        style="width:350px"
                        placeholder="用户手机号/任务编号/订单编号/买手账号/店铺名称"
                        v-model="queryModel.queryTxt"
                        @keydown.enter.native="query"
                        clearable>
                        </el-input>

                        <el-select size="small" style="margin-left:20px;width:100px"  filterable   v-model="queryModel.status" clearable placeholder="处理状态">
                            <el-option  label="处理中" :value="1"> </el-option>
                            <el-option  label="已处理" :value="2"> </el-option>
                            <el-option  label="无效" :value="3"> </el-option>
                        </el-select>
                        <el-date-picker
                        style="margin-left:20px;width:250px"
                        size="small"
                        v-model="queryModel.createTimes"
                        type="daterange"
                        range-separator="至"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期">
                        </el-date-picker>
                        <el-select size="small" style="margin-left:20px;width:100px"  filterable   v-model="queryModel.managerId" clearable placeholder="审核人">
                            <el-option v-for="v in managerList" :key="v.Id" :label="v.RealName" :value="v.Id"> </el-option>
                        </el-select>
                        <el-button size="small" icon="el-icon-search" style="margin-left:20px" @click="queryAction" type="primary">搜索</el-button>
                   </div>
                </div>
                <div>
                    <el-divider content-position="left">订单列表</el-divider>
                    <el-pagination style="float:right;margin-top:-2px"
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="queryModel.pIndex"
                    :page-sizes="[10, 20, 40, 60]"
                    :page-size="queryModel.pSize"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="total">
                    </el-pagination>
                    <el-table
                    v-loading="isLoading"
                    :data="tableData"
                    :height="bodyHeight-130"
                    style="width: 100%">
                        <el-table-column
                        width="180px"
                            label="工单编号">
                            <template slot-scope="scope">
                                <el-link @click="showDetail(scope.row)" target="_blank" icon="el-icon-c-scale-to-original"  type="primary">{{scope.row.Code}}</el-link>
                            </template>
                        </el-table-column>
                        <el-table-column
                            label="店铺名称">
                            <template slot-scope="scope">
                            <el-tooltip class="item" effect="dark" :content="scope.row.ShopName" placement="bottom">
                                <span v-if="scope.row.ShopType==1" >
                                    <div style="margin-left:5px;width:120px; white-space:nowrap; overflow:hidden; text-overflow:ellipsis;">
                                        <img  style="margin-bottom:-5px;height:20px;background-color:#ff6a3c;border-radius:5px"  src="../assets/taobao.png">
                                        {{scope.row.ShopName}}
                                        </div>
                                </span>
                                <span v-else-if="scope.row.ShopType==2" >
                                    <div style="margin-left:5px;width:120px; white-space:nowrap; overflow:hidden; text-overflow:ellipsis;">
                                        <img  style="margin-bottom:-5px;height:20px;background-color:#9765ff;border-radius:5px" src="../assets/jindong.png">
                                        {{scope.row.ShopName}}
                                    </div>
                                </span>
                                <span v-else-if="scope.row.ShopType==6" >
                                    <div style="margin-left:5px;width:120px; white-space:nowrap; overflow:hidden; text-overflow:ellipsis;">
                                        <img  style="margin-bottom:-5px;height:20px;background-color:#9765ff;border-radius:5px" src="../assets/dy.jpg">
                                        {{scope.row.ShopName}}
                                    </div>
                                </span>
                                <span  v-else>
                                    <div style="margin-left:5px;width:120px; white-space:nowrap; overflow:hidden; text-overflow:ellipsis;">
                                        <img  style="margin-bottom:-5px;height:20px;background-color:#fc5487;border-radius:5px"  src="../assets/pinduoduo.png">
                                        {{scope.row.ShopName}}
                                    </div>
                                </span>
                            </el-tooltip>
                            </template>
                        </el-table-column>
                        <el-table-column
                                label="商品名称">
                            <template slot-scope="scope">
                                <el-tooltip class="item" effect="dark" placement="right">
                                    <div slot="content" style="width:200px;line-height:18px">{{scope.row.Title}}</div>
                                    <div style="width:100%; white-space:nowrap; overflow:hidden; text-overflow:ellipsis;">{{scope.row.Title}}</div>
                                </el-tooltip>
                            </template>
                        </el-table-column>
                        <el-table-column
                                prop="OrderCode"
                                label="买手提交单号">
                        </el-table-column>
                        <el-table-column
                                prop="AliTrademanager"
                                label="买手账号">
                        </el-table-column>
                        <el-table-column
                                width="120px"
                                label="任务本金">
                                <template slot-scope="scope">
                                    <el-link type="danger">￥{{scope.row.Price.toFixed(2)}}</el-link>
                                </template>
                        </el-table-column>
                        <el-table-column
                                width="120px"
                                label="买手垫付本金">
                                <template slot-scope="scope">
                                    <el-link type="danger">￥{{scope.row.AdvanceMoney.toFixed(2)}}</el-link>
                                </template>
                        </el-table-column>
                        <el-table-column
                                width="80px"
                                label="任务佣金">
                                <template slot-scope="scope">
                                    <el-link type="danger">￥{{scope.row.ActualCommission.toFixed(2)}}</el-link>
                                </template>
                        </el-table-column>
                        <el-table-column
                                width="100px"
                                label="第三方佣金">
                                <template slot-scope="scope">
                                    <el-link type="danger">￥{{scope.row.Cost.toFixed(2)}}</el-link>
                                </template>
                        </el-table-column>
                        <el-table-column
                                prop="Phone"
                                label="手机">
                        </el-table-column> 
                        <el-table-column
                                prop="Name"
                                label="派单人">
                        </el-table-column> 
                        <el-table-column
                                prop="OrderTime"
                                label="接单时间">
                        </el-table-column>                    
                        <el-table-column
                        label="状态">
                            <template  slot-scope="scope">
                                <el-tag effect="dark"  v-if="scope.row.FeedbackStatus==1" size="mini" >处理中</el-tag>
                                <el-tag effect="dark"  type="success" v-else-if="scope.row.FeedbackStatus==2" size="mini" >已处理</el-tag>
                                <el-tag effect="dark"  type="info" v-else size="mini" >无效</el-tag>
                            </template>
                        </el-table-column>
                        <el-table-column 
                            label="操作" >
                                <template slot-scope="scope">
                                    <el-tooltip v-if="scope.row.FeedbackImgList.length>2" class="item" effect="dark" content="查看商家上传的截图" placement="bottom">
                                        <el-button  size="mini"  @click="seeImgs(scope.row)" icon="el-icon-view" circle></el-button>
                                    </el-tooltip>
                                    <el-tooltip class="item" effect="dark" content="修改这个订单处理状态" placement="bottom">
                                        <el-button  size="mini"  type="primary" @click="chuli(scope.row)" icon="el-icon-edit" circle></el-button>
                                    </el-tooltip>
                                </template>
                        </el-table-column>
                    </el-table>
                </div>
            </div>
        </el-card>

        <el-image-viewer 
                style="z-index:999999"
                v-show="showViewer" 
                :on-close="closeImg" 
                :url-list="imgs" />
        <el-dialog title="反馈处理" :visible.sync="editVisible" width="600px">
            <div>
                <b>
                    问题描述：{{setRow.FeedbackDescription}}
                </b>
            </div>
            <div style="margin-top:20px;">
                <b>商家截图：</b>
                  <el-image 
                    v-for="(v,i) in imgs" :key="i"
                        style="width: 100px; height: 100px"
                        :src="v" 
                        :preview-src-list="imgs">
                    </el-image>
            </div>
            <div style="margin-top:20px;">
                 <b>处理结果：</b>
                <el-radio-group v-model="setModel.feedbackStatus">
                    <el-radio :label="2">已处理</el-radio>
                    <el-radio :label="3">无效</el-radio>
                </el-radio-group>
            </div>
            <div style="margin-top:20px;">
                <b>处理备注：</b>
                <el-input
                style="width:450px"
                type="textarea"
                :rows="3"
                placeholder="请输入处理备注"
                v-model="setModel.feedbackRemark">
                </el-input>
            </div>
            <div slot="footer" class="dialog-footer">
                <el-button @click="editVisible = false">取 消</el-button>
                <el-button type="primary" @click="submitEdit">确 定</el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>

import ElImageViewer from 'element-ui/packages/image/src/image-viewer'

import {managerGetSel,orderGetFeedbackOrder,orderFeedbackOrder} from '@/request.js'
export default {
  name: 'App',
    props:{
        member:{
        type:Object,
        required: true
        }
    },
  components: {
      ElImageViewer
  },
  data() {
    return {
        showViewer:false,
        bodyHeight:0,
        total:0,
        queryModel:{
            queryTxt:"",
            shopId:"",
            status:"",
            pIndex:1,
            pSize:10,
            createTimes:[],
            isOver:true,
            managerId:"",
        },
        tableData:[],
        imgs:[],
        editVisible:false,
        setRow:{},
        isLoading:false,
        managerList:[],
        setModel:{
            feedbackStatus:0,
            feedbackRemark:"",
            orderId:0,
        }
    };
  },
  watch:{
  },
  created() {
        this.bodyHeight=document.documentElement.clientHeight-129;
  },
  mounted() {
      managerGetSel({},(res)=>{
            this.managerList=res.Result;
        });
       let taskcode = this.$route.query.taskcode;
       let queryTxt = this.$route.query.queryTxt;
       if(taskcode){
           this.queryModel.queryTxt=taskcode;
       }
       if(queryTxt){
           this.queryModel.queryTxt=queryTxt;
       }
      this.query();
  },
   methods:{
       chuli(scope){
           this.setRow=scope;
           this.imgs=JSON.parse(scope.FeedbackImgList);
           this.editVisible=true;
           this.setModel.feedbackStatus=scope.FeedbackStatus;
           this.setModel.feedbackRemark=scope.FeedbackRemark;
           this.setModel.orderId=scope.Id;
       },
       submitEdit(){
           if(this.setModel.feedbackStatus<2){
                this.$message({
                    message: '请选择一个处理结果',
                    type: 'warning'
                });
                return;
           }
           orderFeedbackOrder(this.setModel,(res)=>{
                if(res.IsSuccess){
                    this.$message({
                        message: '处理成功',
                        type: 'success'
                    });
                    this.setRow.FeedbackRemark=this.setModel.feedbackRemark;
                    this.setRow.FeedbackStatus=this.setModel.feedbackStatus;
                    this.editVisible=false;
                }else{
                    this.$message.error(res.Message);
                }
           });
       },
       closeImg(){
            this.showViewer=false;
        },
       seeImgs(scope){
           this.imgs=JSON.parse(scope.FeedbackImgList);
           this.showViewer=true;
       },

       queryAction(){
           this.queryModel.pIndex=1;
           this.query();
       },
       query(){
           this.isLoading=true;
           orderGetFeedbackOrder({
               queryTxt:this.queryModel.queryTxt,
               status:this.queryModel.status==""?0:parseInt(this.queryModel.status),
               shopId:this.queryModel.shopId==""?0:parseInt(this.queryModel.shopId),
               pIndex:this.queryModel.pIndex,
               pSize:this.queryModel.pSize,
               createTimes:this.queryModel.createTimes==null?"[]":JSON.stringify(this.queryModel.createTimes),
               isOver:true,
               managerId:this.queryModel.managerId==""?0:parseInt(this.queryModel.managerId),

           },(res)=>{
               this.tableData=res.Result;
               this.total=res.TotalCount;
               this.isLoading=false;
           })
       },
        handleSizeChange(val){
            this.queryModel.pSize=val;
            this.query();
        },
        handleCurrentChange(val){
            this.queryModel.pIndex=val;
            this.query();
        },
   },
}
</script>